function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityBabysitterFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.592 20.442h-4.233c-3.746 0-6.852-2.794-7.341-6.409h18.915c-.49 3.615-3.595 6.41-7.341 6.41zm-.917-16.68a9.287 9.287 0 014.842 2.015l-4.842 4.843V3.762zm8.27 8.271H21.09l4.842-4.84a9.264 9.264 0 012.015 4.84zM18.676 1.71a1 1 0 00-1 1v9.324H8.364L3.707 7.381 2.293 8.796l4.68 4.675c.23 4.985 4.346 8.971 9.386 8.971h4.233c5.187 0 9.408-4.22 9.408-9.409C30 6.79 24.92 1.71 18.675 1.71zm3.8 26a1.45 1.45 0 010-2.9c.8 0 1.45.65 1.45 1.45a1.45 1.45 0 01-1.45 1.45zm0-4.9a3.453 3.453 0 00-3.45 3.45 3.453 3.453 0 003.45 3.45 3.453 3.453 0 003.45-3.45 3.454 3.454 0 00-3.45-3.45zm-8 4.9a1.45 1.45 0 010-2.9c.8 0 1.45.65 1.45 1.45a1.45 1.45 0 01-1.45 1.45zm0-4.9a3.453 3.453 0 00-3.45 3.45 3.453 3.453 0 003.45 3.45 3.453 3.453 0 003.45-3.45 3.454 3.454 0 00-3.45-3.45z",
    fill: props.color
  }));
}

export default SvgIconFacilityBabysitterFilled;